import { z } from 'zod';
import { createNumericKeyRecordSchema } from '../KeyRecordSchemas.ts';
import { twoDiceSumSchema } from '../SharedZodSchemas.ts';
import { createPartialStrictObjectSchemaWithAtLeastOneProperty } from '../PartialStrictObjectSchema.ts';
import { validateState } from '../ValidateState.ts';
import { TileHexType } from './TileHexState.ts';
export const fogTileGroupStateSchema = z.object({
    fogTileIndexes: z.array(z.number().int().nonnegative()),
    possibleTileTypes: z.array(z.enum(TileHexType)),
    possibleDiceNumbers: z.array(twoDiceSumSchema)
}).strict();
export function validateFogTileGroupState(data) {
    return validateState(fogTileGroupStateSchema, data);
}
export const fogTileGroupStatesSchema = createNumericKeyRecordSchema(fogTileGroupStateSchema);
export function validateFogTileGroupStates(data) {
    return validateState(fogTileGroupStatesSchema, data);
}
export const fogTileGroupStatePartialSchema = createPartialStrictObjectSchemaWithAtLeastOneProperty(fogTileGroupStateSchema);
export const fogTileGroupStatesPartialSchema = createNumericKeyRecordSchema(fogTileGroupStatePartialSchema, {
    requireAtLeastOneEntry: true
});
